import React, { useState, useEffect, useCallback } from "react";
import jalaali from "jalaali-js";
import { Col, Button, Row } from "react-bootstrap";
import _ from "lodash";
import { useForm, Controller, FormProvider } from "react-hook-form";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import HistoryIcon from "@mui/icons-material/History";
import SwalMessage from "../_Components/SwalMessage";
import Swal from "sweetalert2";
import ApiAmusementService from "../../../core/api/api.amusementService";
import ApiAmusementServiceReserveItemGroup from "../../../core/api/api.amusementServiceReserveItemGroup";
import ApiAmusementServiceReserveItem from "../../../core/api/api.amusementServiceReserveItem";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import EyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Checkbox, FormControlLabel } from "@mui/material";
import HelpTextModal from "./components/HelpTextModal";
import ChangesHistoryModal from "./components/ChangesHistoryModal";
import CreateReserveFormDate from "./components/CreateReserveFormDate";
import SelectComponent from "../_Components/ReactSelectComponent";
import AddDescriptionModal from "./components/AddDescriptionModal";
import CopyDescription from "./components/CopyDescription";

const AmusementServiceReservationForm = () => {
  const [services, setServices] = useState([]);
  const [service, setService] = useState();
  const [reserveItems, setReserveItems] = useState([]);
  const [reserveItemGroups, setReserveItemGroups] = useState([]);
  const methods = useForm();
  const [showModalAddDescription, setShowModalAddDescription] = useState(false);
  const [reserveDescriptions, setReserveDescriptions] = useState([]);
  const [dates, setDates] = useState([]);
  const [reserveDetail, setReserveDetail] = useState({ service: null, reserveDetailJson: null });
  const [reserveFormCopyModal, setReserveFormCopyModal] = useState({ isShow: false, dateItems: null });
  const [selectedService, setSelectedService] = useState(0);
  const [modalNameDate, setModalNameDate] = useState("");
  const [showAllActiveItems, setShowAllActiveItems] = useState(false);
  const [showModalHelp, setShowModalHelp] = useState(false);
  const [showHelpIcon, setShowHelpIcon] = useState(false);
  const [showHelpLabel, setShowHelpLabel] = useState(false);
  const [text, setText] = useState("");
  const [showModalChangesHistory, setShowModalChangesHistory] = useState(false);

  const showHelpModalDescription = (text) => {
    setShowModalHelp(true);
    setText(text);
  };

  // Fetch all services
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await ApiAmusementService.getAllServices();
        if (!_.isEmpty(data)) {
          setServices(data);
        }
      } catch { }
    };
    fetchServices();
  }, []);

  useEffect(() => {
    const today = new Date();
    const thirtyDaysFromNow = new Date(today);
    thirtyDaysFromNow.setDate(today.getDate() + 30);
    const toJalaali = (date) => {
      const jDate = jalaali.toJalaali(date);
      return `${jDate.jy}/${("0" + jDate.jm).slice(-2)}/${("0" + jDate.jd).slice(-2)}`;
    };
    const formattedToday = toJalaali(today);
    const formattedThirtyDaysFromNow = toJalaali(thirtyDaysFromNow);
    methods.setValue("dateTimeStart", formattedToday);
    methods.setValue("dateTimeEnd", formattedThirtyDaysFromNow);
  }, []);
  // ایجاد تاریخ تا 30 روز آینده
  const createDates = (allDates) => {
    const tempDatest = [];
    const days = [];
    allDates.map((item) => {
      const nameDate = item.year + item.month + item.day;
      days.push({ formattedDate: item.date, nameDate, persianDayOfWeek: item.persianDayOfWeek });
    });

    setDates(days);

    // تمام فیلد های فرم را ریست میکنه که دیفالت ولیو جدید بتونه ثبت بشه
    dates.forEach(({ formattedDate, nameDate }) => {
      methods.resetField(`${nameDate}-IA`);
      methods.resetField(`${nameDate}-ID`);
      methods.resetField(`${nameDate}-Des`);

      reserveItemGroups.forEach((group) => {
        methods.resetField(`${nameDate}-${group.id}-ID`);
        methods.resetField(`${nameDate}-${group.id}-IA`);
        methods.resetField(`${nameDate}-${group.id}-Des`);

        reserveItems.forEach((item) => {
          methods.resetField(`${nameDate}-${group.id}-${item.id}-ID`);
          methods.resetField(`${nameDate}-${group.id}-${item.id}-IA`);
          methods.resetField(`${nameDate}-${group.id}-${item.id}-C`);
          methods.resetField(`${nameDate}-${group.id}-${item.id}-IFC`);
          methods.resetField(`${nameDate}-${group.id}-${item.id}-MinC`);
        });
      });
    });
  };

  // جدا کردن ساعت و دقیقه از مقدار زمان
  const formatTime = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":");
    return `${hours}:${minutes}`;
  };


  const handleModalClose = useCallback(() => setShowModalAddDescription(false), []);



  const onSubmitViewItems = async (data) => {
    let startDate = "";
    let endDate = "";
    if (data?.dateTimeStart && typeof data.dateTimeStart === "object") {
      startDate =
        data.dateTimeStart.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
        data.dateTimeStart.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
        data.dateTimeStart.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
    } else {
      startDate = data.dateTimeStart.replaceAll("/", "");
    }
    if (data?.dateTimeEnd && typeof data.dateTimeEnd === "object") {
      endDate =
        data.dateTimeEnd.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
        data.dateTimeEnd.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
        data.dateTimeEnd.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
    } else {
      endDate = data.dateTimeEnd.replaceAll("/", "");
    }
    await getSelectedServiceData(startDate, endDate);
  };

  const onSubmit = async (data) => {
    var amusementReserveItems = dates
      .map(({ formattedDate, nameDate }) => {
        if (data[`${nameDate}-IA`] != null) {
          return {
            d: nameDate,
            dIA: data[`${nameDate}-IA`], // DateIsActive
            dDesId: data[`${nameDate}-Des`]?.value, // DateDescriptionId
            g: reserveItemGroups.map((group) => ({
              // reserveItemGroups
              gId: group.id, // groupId
              gID: data[`${nameDate}-${group.id}-ID`], // GroupIsDisplay
              gIA: data[`${nameDate}-${group.id}-IA`], // GroupIsActive
              gDesId: data[`${nameDate}-${group.id}-Des`]?.value, // GroupDescriptionId
              i: reserveItems.map((item) => ({
                // reserveItems
                iId: item.id, // itemId
                iID: data[`${nameDate}-${group.id}-${item.id}-ID`], // ItemIsDisplay
                iIA: data[`${nameDate}-${group.id}-${item.id}-IA`], // ItemIsActive
                iC: data[`${nameDate}-${group.id}-${item.id}-C`], // ItemCapacity
                iIDL: data[`${nameDate}-${group.id}-${item.id}-IDL`], // ItemIsDailyLimit
                iIFC: data[`${nameDate}-${group.id}-${item.id}-IFC`], // ItemIsFullCapacity
                iMinC: data[`${nameDate}-${group.id}-${item.id}-MinC`], // MinimumReserveCountPerDay
              })),
            })),
          };
        } else {
          return null;
        }
      })
      .filter((item) => item !== null); // حذف موارد null
    const jsonAmusementReserveItems = JSON.stringify(amusementReserveItems);
    try {
      const response = await ApiAmusementService.updateAmusementReserveDetail({
        id: service,
        ReserveDetail_V2: jsonAmusementReserveItems,
        beOverwritten: checkedCheckboxOverwriteDate,
      });
      if (response?.succeeded) {
        SwalMessage({
          title: "تغییرات با موفقیت اعمال شد.",
          iSsuccess: true,
        });
      } else {
        await SwalMessage({
          title: response?.message ? response?.message : "خطا در روند اجرای برنامه!",
          iSsuccess: false,
        });
      }
    } catch (error) {
      await SwalMessage({
        title: "خطا در روند اجرای برنامه!!",
        iSsuccess: false,
      });
    }
  };



  const inputChangeHandler2 = async (selectedOption) => {
    setSelectedService(selectedOption?.value || 0);
    setShowHelpIcon(true);
  };
  const getSelectedServiceData = async (startDate, endDate) => {
    if (selectedService === 0) {
      SwalMessage({
        title: "ابتدا تفریح مورد نظر را انتخاب کنید.",
        iSsuccess: false,
        timer: 5000,
      });
      return;
    }
    const response =
      _.isEmpty(startDate) || _.isEmpty(endDate)
        ? await ApiAmusementService.getReserveDetails({ id: selectedService })
        : await ApiAmusementService.getReserveDetails({ id: selectedService, startDate: startDate, endDate: endDate });
    const descriptionsObject = JSON.parse(response.reserveDetail_V2Descriptions);
    const formattedDescriptions = !_.isNil(descriptionsObject)
      ? descriptionsObject?.map((desc) => ({
        value: desc.id,
        label: desc.desc,
      }))
      : [];
    setReserveDescriptions(formattedDescriptions);
    setService(selectedService);

    createDates(response.fullDateTimeDtos);
    // تنظیم مقادیر ورودی‌ها با داده‌های ذخیره‌شده
    const reserveDetailObject = JSON.parse(response.reserveDetail_V2);
    setReserveDetail({ service: selectedService, reserveDetailJson: reserveDetailObject });
    setReserveItems([]);
    setReserveItemGroups([]);
    const amusementServiceReserveItems = await ApiAmusementServiceReserveItem.getAllReserveItems(selectedService);
    if (!_.isEmpty(amusementServiceReserveItems)) {
      const activeItems = amusementServiceReserveItems.filter(a => a.isActive);
      setReserveItems(activeItems);
    }
    const itemGroupResponse = await ApiAmusementServiceReserveItemGroup.getAllReserveItemGroups(selectedService);
    if (!_.isEmpty(itemGroupResponse)) {
      const activeItemGroupResponse = itemGroupResponse.filter(a => a.isActive);
      setReserveItemGroups(activeItemGroupResponse);
    }
  };


  useEffect(() => {
    (async () => {
      if (selectedService != 0) {
        let dateTimeStart = methods.getValues("dateTimeStart");
        let dateTimeEnd = methods.getValues("dateTimeEnd");
        let startDate = "";
        let endDate = "";
        if (dateTimeStart !== null && typeof dateTimeStart === "object") {
          startDate =
            dateTimeStart.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
            dateTimeStart.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
            dateTimeStart.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
        } else {
          startDate = dateTimeStart.replaceAll("/", "");
        }
        if (dateTimeEnd !== null && typeof dateTimeEnd === "object") {
          endDate =
            dateTimeEnd.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
            dateTimeEnd.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
            dateTimeEnd.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
        } else {
          endDate = dateTimeEnd.replaceAll("/", "");
        }
        await getSelectedServiceData(startDate, endDate);
        resetAllFormInputs();

      }
    })();
  }, [selectedService, methods.reset]);
  const resetAllFormInputs = () => {
    //Reset all date checked box field for show new default value
    dates.map(function ({ nameDate }) {
      if (!_.isNil(methods.getValues(`${nameDate}-IA`))) methods.resetField(`${nameDate}-IA`);
      if (!_.isNil(methods.getValues(`${nameDate}-Des`))) methods.resetField(`${nameDate}-Des`);
      reserveItemGroups.map(function (group) {
        if (!_.isNil(methods.getValues(`${nameDate}-${group.id}-Des`))) methods.resetField(`${nameDate}-${group.id}-Des`);
      });
    });
  };
  const deleteAmusementReserveDetail = async () => {
    if (selectedService) {
      Swal.fire({
        title: "عملیات حذف فرم رزرو",
        text: "از حذف فرم رزرو اطمینان دارید؟",
        icon: "question",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "بله",
        denyButtonText: "خیر",
        cancelButtonText: "انصراف",
        customClass: {
          actions: "my-actions",
          cancelButton: "order-1 right-gap btn btn-secondary ",
          confirmButton: "order-2 btn btn-success px-5",
          denyButton: "order-3 btn btn-danger px-5",
        },
        focusCancel: true
      }).then((result) => {
        if (result.isConfirmed) {
          // (async () => {
          try {
            const responsePromise = ApiAmusementService.deleteAmusementReserveDetail(selectedService);
            responsePromise.then((response) => {
              if (response.succeeded == true) {
                SwalMessage({
                  title: response.message,
                  iSsuccess: true,
                });
                //Reset all date checked box field for show new default value
                dates.map(function ({ nameDate }) {
                  methods.resetField(`${nameDate}-ID`);
                  methods.resetField(`${nameDate}-IA`);
                  methods.resetField(`${nameDate}-Des`);
                  reserveItemGroups.map(function (group) {
                    methods.resetField(`${nameDate}-${group.id}-Des`);
                    methods.resetField(`${nameDate}-${group.id}-ID`);
                    methods.resetField(`${nameDate}-${group.id}-IA`);
                    reserveItems.map(function (item, itemIndex) {
                      methods.resetField(`${nameDate}-${group.id}-${item.id}-ID`);
                      methods.resetField(`${nameDate}-${group.id}-${item.id}-IA`);
                      methods.resetField(`${nameDate}-${group.id}-${item.id}-IDL`);
                      methods.resetField(`${nameDate}-${group.id}-${item.id}-IFC`);
                    });
                  });
                });
                methods.handleSubmit(onSubmitViewItems)();
              }
            });
          } catch (error) {
          }
          //}
          //)
        }
      });
    } else {
      SwalMessage({ title: "ابتدا تفریح مورد نظر را انتخاب کنید.", iSsuccess: false });
    }
  };
  const showHistoryModal = async () => {
    setShowModalChangesHistory(true);
  };

  const [checkedCheckboxOverwriteDate, setCheckedCheckboxOverwriteDate] = useState(false);

  const handleChangeCheckboxOverwriteDate = (event) => {
    setCheckedCheckboxOverwriteDate(event.target.checked);
  };
  const showSweetAlertForShowHelpLabel = () => {
    setShowHelpLabel(!showHelpLabel);
    if (!showHelpLabel) {
      Swal.fire({
        title: "راهنما",
        text: "برای مشاهده توضیحات بیشتر هر قسمت، روی لیبل های رنگی کلیک کنید.",
        showDenyButton: false,
        icon: "info",
        timer: 8000,
        showConfirmButton: false,
        position: "bottom-end",
        focusCancel: true
      });
    }
  };

  return (
    <>
      <div className="card card-custom p-5">
        <div className="card-header border-0 p-0">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت فرم رزرو</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">ثبت و به روزرسانی فرم های رزرو</span>
          </h3>
          <div className="card-toolbar">

          </div>
        </div>

        <div className="border-top">
          {showHelpIcon && (
            <div
              className=" position-fixed rounded-3 rounded-start-0 px-2 py-2 text-white text-center"
              style={{ left: "0px", top: "50%", zIndex: "1", backgroundColor: "#5050a3", cursor: "pointer" }}
              onClick={() => showSweetAlertForShowHelpLabel()}
            >
              {!showHelpLabel ? (
                <>
                  <EyeIcon className="mr-1" />
              راهنما
                </>
              ) : (
                <>
                  <VisibilityOff className="mr-1" />
              راهنما
                </>
              )}
            </div>
          )}
          <form noValidate autoComplete="off" className="mt-3" onSubmit={methods.handleSubmit(onSubmitViewItems)}>
            <Row className="mb-3 align-items-center">
              <Col xs="12" sm="4" md>
                <Controller
                  name="dateTimeStart"
                  control={methods.control}
                  render={({ field: { onChange, value } }) => (
                    <ShamsiDatePicker className="mt-5" value={value} onChange={onChange} placeholder="از تاریخ" />
                  )}
                />
              </Col>
              <Col xs="12" sm="4" md>
                <Controller
                  name="dateTimeEnd"
                  control={methods.control}
                  render={({ field: { onChange, value } }) => {
                    return <ShamsiDatePicker className="mt-5" value={value} onChange={onChange} placeholder="تا تاریخ" />;
                  }}
                />
              </Col>

              <Col xs="12" sm="4" md>
                <SelectComponent
                  name="service"
                  className="mt-5 w-100"
                  variant="outlined"
                  placeholder="انتخاب سرویس"
                  options={services?.map((item) => ({
                    value: item.id,
                    label: item.name,
                    type: "service",
                  }))}
                  noLabel
                  value={services?.map(item => ({
                    value: item.id,
                    label: item.name,
                    type: "service",
                  })).find(item => item.value == selectedService) || null}
                  onChange={inputChangeHandler2}
                />
              </Col>
              <Col xs="3" sm="4" md="auto" className="text-center">
                <Button
                  variant="secondary"
                  type="submit"
                  className="mt-5 mt-md-3 w-100 "
                  color="success"
                  style={{ height: "37px" }}
                >
                  نمایش
            </Button>
              </Col>
            </Row>
          </form>

        </div>

        <form noValidate autoComplete="off" onSubmit={methods.handleSubmit(onSubmit)}>
          <Row>
            <Col xs="12" xl="auto" className="text-md-center d-md-flex align-items-start mt-1">
              <Button type="submit" color="primary">
                <SaveIcon className="mr-1" />
              ذخیره
            </Button>
              <Button variant="danger" type="button" className=" mx-2" onClick={deleteAmusementReserveDetail}>
                <DeleteIcon className="mr-1" />
              حذف فرم رزرو
            </Button>
            </Col>
            <Col xs="12" md="auto" className="mt-5 mt-xl-1 pl-xl-0">
              <FormControlLabel
                style={{ border: "1px solid #ced1dd" }}
                className=" custom-label-checkbox bg-secondary rounded-3 mb-0 px-2 py-1 py-xl-0"
                control={
                  <Checkbox
                    checked={checkedCheckboxOverwriteDate}
                    onChange={handleChangeCheckboxOverwriteDate}
                    name="checkboxOverwriteDate"
                    color="primary"
                  />
                }
                label="صرفا تاریخ های این صفحه نگه داری شود و مابقی تاریخ ها حذف گردد."
              />
            </Col>
            <Col xs="12" md="auto" className="mt-5 mt-xl-1">
              <FormControlLabel
                style={{ border: "1px solid #ced1dd" }}
                className="custom-label-checkbox bg-secondary rounded-3 mb-0 px-2 py-1 py-xl-0"
                control={
                  <Checkbox
                    checked={showAllActiveItems}
                    onChange={() => setShowAllActiveItems(!showAllActiveItems)}
                    name="checkboxSetActiveItems"
                    color="primary"
                  />
                }
                label="نمایش تمام آیتم های فعال"
              />
            </Col>
            <Col xs="12" md="auto" className="mt-5 mt-xl-1">
              <Button variant="info" type="button" className="mx-2" color="success" onClick={showHistoryModal}>
                <HistoryIcon className="mr-1" />
              تاریخچه تغییرات
            </Button>
            </Col>
          </Row>
        </form>
      </div>

      <FormProvider {...methods}>

        {reserveDetail.service == selectedService && <Row className="mt-4">
          {/* {ss()} */}
          {dates.map((date, index) => (
            <CreateReserveFormDate
              key={date + index}
              selectedService={selectedService}
              reserveDetail={reserveDetail}
              date={date}
              showAllActiveItems={showAllActiveItems}
              reserveDescriptions={reserveDescriptions}
              reserveItemGroups={reserveItemGroups}
              reserveItems={reserveItems}
              setReserveFormCopyModal={setReserveFormCopyModal}
              showHelpLabel={showHelpLabel}
              showHelpModalDescription={showHelpModalDescription}
              formatTime={formatTime}
              setModalNameDate={setModalNameDate}
              setShowModalAddDescription={setShowModalAddDescription}
            />
          )
          )}
        </Row>}

        {showModalAddDescription &&
          <AddDescriptionModal
            showModalAddDescription={showModalAddDescription}
            handleModalClose={handleModalClose}
            modalNameDate={modalNameDate}
            setReserveDescriptions={setReserveDescriptions}
            service={service}
            reserveDescriptions={reserveDescriptions}
            setShowModalAddDescription={setShowModalAddDescription}
          />}
        {reserveFormCopyModal.isShow &&
          <CopyDescription
            reserveFormCopyModal={reserveFormCopyModal}
            setReserveFormCopyModal={setReserveFormCopyModal}
            reserveItemGroups={reserveItemGroups}
            reserveItems={reserveItems}
            dates={dates}
          />}
      </FormProvider>
      { showModalHelp && <HelpTextModal showModalHelp={showModalHelp} setShowModalHelp={setShowModalHelp} text={text} />}
      {
        showModalChangesHistory && (
          <ChangesHistoryModal
            showModalChangesHistory={showModalChangesHistory}
            setShowModalChangesHistory={setShowModalChangesHistory}
            selectedServiceId={selectedService}
          />
        )
      }
    </>
  );
};

export default AmusementServiceReservationForm;